import type { Mission } from '../missions.ts'

export const blm: Mission = {
  id: "blm",
  name: "Bureau of Land Management",
  short: "BLM",
  call: "Land",
  kind: "subagency",
  parent: "doi",
  url: "https://www.blm.gov/",
  established: 1946,
  palette: {
    primary: "#437657",
    secondary: "#5f8bbb",
    accent: "#acce64",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Bureau_of_Land_Management.svg",
  },
  motif: "mountain",
  mission: {
    text: "The Bureau of Land Management's mission is to sustain the health, diversity, and productivity of public lands for the use and enjoyment of present and future generations.",
    url: "https://www.blm.gov/about/our-mission",
  },
  fact: {
    text: "Established in 1946 by merging the General Land Office and the U.S. Grazing Service, the BLM manages 245 million acres of public lands, one in ten acres in the country.",
    url: "https://www.blm.gov/about",
  },
  seal: {
    file: "public/seals/blm.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Bureau_of_Land_Management.svg",
  },
  identifier: {
    about: "https://www.blm.gov/about",
    accessibility: "https://www.doi.gov/accessibility",
    foia: "https://www.blm.gov/services/foia",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.doi.gov/bpp",
    privacy: "https://www.doi.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/blm-missouri-breaks.jpg",
        small: "/media/blm-missouri-breaks-sm.jpg",
        alt: "The Missouri River winds past islands of autumn cottonwoods between eroded, banded badlands.",
        title: "Upper Missouri River Breaks National Monument, Montana",
        creator: "Bureau of Land Management",
        source: "https://commons.wikimedia.org/wiki/File:Upper_Missouri_Breaks_NM_(8914214495).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/blm-valley-of-the-gods.jpg",
        small: "/media/blm-valley-of-the-gods-sm.jpg",
        alt: "Sandstone boulders and desert scrub in front of towering red-rock buttes under a sky of white clouds.",
        title: "Red-rock buttes on public lands in southeastern Utah",
        creator: "Bob Wick, Bureau of Land Management",
        source: "https://commons.wikimedia.org/wiki/File:-TravelTuesday_with_My_Public_Lands_(24446462030).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
